import React, { Component } from 'react';

import JSONLDUtils from 'common/util/JsonLdUtils';

import Helmet from './Helmet';

const Title = 'Internal Feedback | Canny';
const Description =
  "Manage ideas from your internal team. Don't let their feedback get lost in the shuffle.";
const Image = 'https://canny.io/images/canny-social.png';
const InternalFeedbackUrl = 'https://canny.io/use-cases/internal-feedback';

const jsonLdGraph = JSONLDUtils.createGraph([
  JSONLDUtils.createWebPage({
    '@id': `${InternalFeedbackUrl}#webpage`,
    url: InternalFeedbackUrl,
    name: 'Internal Feedback Management - Canny',
    description:
      'Collect and manage internal feedback from your team with Canny, helping you prioritize improvements and streamline communication.',
    inLanguage: 'en',
    about: { '@id': 'https://canny.io/#app' },
    isPartOf: { '@id': 'https://canny.io/#website' },
  }),
  JSONLDUtils.createWebApplicationItemList(
    `${InternalFeedbackUrl}#capabilities`,
    'Internal Feedback Capabilities',
    [
      {
        name: 'Collect Feedback Across Teams',
        description:
          'Enable employees to share ideas, issues, and feature suggestions in a centralized platform.',
      },
      {
        name: 'Organize and Prioritize Internal Requests',
        description:
          'Structure and rank internal feedback to focus on improvements with the greatest impact.',
      },
      {
        name: 'Integrate Feedback into Product Planning',
        description:
          'Link internal insights directly to your roadmap to align internal and external priorities.',
      },
      {
        name: 'Close the Loop with Teams',
        description:
          'Communicate progress on internal requests, ensuring visibility and alignment across the organization.',
      },
    ],
  ),
  JSONLDUtils.createBreadcrumbList([
    { name: 'Home', item: 'https://canny.io/' },
    { name: 'Use Cases', item: 'https://canny.io/use-cases' },
    { name: 'Internal Feedback', item: InternalFeedbackUrl },
  ]),
]);

export default class LandingInternalFeedbackHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },

          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: InternalFeedbackUrl },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}>
        <script type="application/ld+json">{JSONLDUtils.toString(jsonLdGraph)}</script>
      </Helmet>
    );
  }
}
